/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * Colours to apply to all Highcharts charts.
 */
export const HIGHCHARTS_CHART_COLOURS: Array<string> = [
  '#044985',
  '#8fc0eb',
  '#024752',
  '#8fd0d9',
  '#6b1211',
  '#ec9c9b',
];

/**
 * Single colour used for the Highcharts Sankey chart.
 */
export const HIGHCHARTS_SANKEY_COLOURS: Array<string> = ['#044985'];

/**
 * Default setting for Highcharts charts.
 */
export const HIGHCHARTS_DEFAULT_OPTIONS: Highcharts.Options = {
  colors: HIGHCHARTS_CHART_COLOURS,
  credits: { enabled: false },
  legend: { enabled: false },
};
